import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import { Translation, Trans } from 'react-i18next';
import classNames from 'classnames';
import ComponentHeader from '../ecap/ComponentHeader';
import { getUserDashboardInfo } from '../../store/actions';
import { getOnboardingState, getEcapState } from '../../store/selectors';
import CareerClassProgress from './utility/classProgressUtil/CareerClassProgress';

const createPlanStyles = {
  color: (props) => ({
    backgroundColor: props.tenant.primary,

    '&:hover': {
      border: `2px solid ${props.tenant.primary}`,
      color: `${props.tenant.primary}`,
    },
  }),
};

class ClassProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  secondaryColorBar = {
    height: '3px',
    width: '62px',
    backgroundColor: `${this.props.tenant.secondary}`,
    marginBottom: '15px',
  };

  primaryBackgroundColor = {
    backgroundColor: `${this.tenantPrimary}`,
  };

  get tenantPrimary() {
    return this.props.tenant.primary;
  }

  get ecapData() {
    if (
      this.props.location.pathname.includes('user-profile') &&
      !Object.values(this.props.userProfile.degreeChoices).some(
        (degree) => degree.length === 0
      )
    ) {
      return true;
    }
    if (
      this.props.location.pathname.includes('user-profile') &&
      Object.values(this.props.userProfile.degreeChoices).some(
        (degree) => degree.length === 0
      )
    ) {
      return false;
    }
    return true;
  }

  getCareerChoices = () => {
    return {
      1: this.props.userProfile.careerGameResults[0],
      2: this.props.userProfile.careerGameResults[1],
      3: this.props.userProfile.careerGameResults[2],
    };
  };

  displayModal = () => {
    return !Object.values(this.props.ecap.plan.classes_matched).some(
      (classes) => {
        return classes.length !== 0;
      }
    );
  };

  displayModalAdvisorDashboard = () => {
    if (this.props.userProfile.ecapPlan) {
      return !Object.values(
        this.props.userProfile.ecapPlan.classes_matched
      ).some((classes) => {
        return classes.length !== 0;
      });
    }
    return true;
  };

  /* eslint-disable react/jsx-one-expression-per-line */
  render() {
    const careerChoices = this.props.location.pathname.includes('user-profile')
      ? this.getCareerChoices()
      : this.props.onboarding.careerChoices;
    const displayModal = this.props.location.pathname.includes('user-profile')
      ? this.displayModalAdvisorDashboard()
      : this.displayModal();
    return (
      <Translation>
        {(t) => (
          <div id="class-progress" className="class-progress">
            <ComponentHeader
              parent="dashboard"
              headerText={
                this.props.location.pathname.includes('user-profile')
                  ? t('ECAP Details')
                  : t('Education and Career Action Plan')
              }
              tenant={this.props.tenant}
            />
            <p className="class-progress__subheader">
              {!this.props.location.pathname.includes('user-profile') &&
                t(
                  'Below is the progress you’ve made towards eligibility for your Top 3 degree programs.'
                )}
            </p>
            <div
              className={classNames({
                'class-progress__no-classes-modal':
                  displayModal && this.ecapData,
                'class-progress__no-classes-modal user-profile-no-ecap-data':
                  displayModal && !this.ecapData,
                'class-progress__display-none': !displayModal,
              })}
            >
              <div className="class-progress__modal-subheader1">
                {this.props.location.pathname.includes('user-profile')
                  ? t(
                      'It looks like they haven’t started filling out their classes.'
                    )
                  : t(
                      'It looks like you haven’t started filling out your classes.'
                    )}
              </div>
              <div style={this.secondaryColorBar} />
              {!this.props.location.pathname.includes('user-profile') && (
                <>
                  <div className="class-progress__modal-subheader2">
                    <Trans>
                      Click <span className="bold">Create Plan</span> to start!
                    </Trans>
                  </div>
                  <button
                    type="button"
                    tabIndex={0}
                    onClick={() => this.props.history.push(`education-plan`)}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key))
                        this.props.history.push(`education-plan`);
                    }}
                    className={`button--primary primary-filled class-progress__modal-button ${this.props.classes.color}`}
                    style={this.primaryBackgroundColor}
                  >
                    {t('Create Plan')}
                  </button>
                </>
              )}
            </div>
            {this.ecapData && (
              <div className="class-progress__content">
                {Object.values(careerChoices).map((career) => {
                  return (
                    <CareerClassProgress
                      tenant={this.props.tenant}
                      key={career.id}
                      career={career}
                      displayProgress={
                        this.props.location.pathname.includes('user-profile')
                          ? !this.displayModalAdvisorDashboard()
                          : !this.displayModal()
                      }
                      location={this.props.location}
                    />
                  );
                })}
              </div>
            )}
          </div>
        )}
      </Translation>
    );
  }
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const ecap = getEcapState(state);
  const userProfile = state.admin.userProfileInfo;
  return { onboarding, ecap, userProfile };
}

const ClassProgressWithRouter = withRouter(
  connect(mapStateToProps, { getUserDashboardInfo })(ClassProgress)
);

export default withStyles(createPlanStyles)(ClassProgressWithRouter);
